$('.acc-trigger').on('click', function () {
  $(this).next().stop().slideToggle();
  $(this).toggleClass('is-active');
  return false;
});

